function setupRActionCall() {
  ractionSetup('#rcall');
  $('.js-dial-representative').click(function(event){
    event.preventDefault()
    button = this
    var form = $(this).closest('form')
    validate_form(form)
    email_validation(form)
    postcode_validation(form)
    standard_validators()
    payload = {
      decision_id: $(this).data('decision-id'),
      campaign_id: $(this).data('campaign-id'),
      rcall_id: $('#rcall .js-rcall-id').val(),
      use_known_member_data:$('#rcall .known-member input[name=use_known_member_data]').val(),
      known_member_data:$('#rcall .known-member input[name=known_member_data]').val(),
      email: $('#rcall .js-member-email input').val(),
      phone: $('#rcall .js-member-phone input').val(),
      name: $('#rcall .js-member-name input').val() || $('#rcall .js-member-firstname input').val(),
      postcode: $('#rcall .js-member-postcode input').val() || $('#rcall .js-member-postcode select').val(),
      source_id: $('#rcall input[name="rcall[source_id]"]').val()
    }
    if ($('#rcall :invalid').length === 0){
      setCallingOn(button);
      $.post('/twilio/api/call/start', payload, function(data){
        $('#rcall .js-rcall-id').val(data.rcall_id)
        // Start the polling to monitor the call status
        pollCallingStatus(data.rcall_recipient_id)
      }).fail(function(){
        setCallingOff(button);
      })
    }
  })

  $('.js-call-again-button').click(function(event){
    event.preventDefault()
    showCallingListScreen()
  })

  $('#rcall form').submit(function () {
    $('#rcall button').prop('disabled', true);
    $('#rcall .fa-spinner').show();
    $.post($(this).attr('action'), $(this).serialize()).done(function (data) {
      nextAction();
    }).fail(function (jqXHR) {
      $('#rcall').replaceWith(jqXHR.responseText);
    });
    return false;
  });
}

function pollCallingStatus(rcallRecipientId){
  $.getJSON('/twilio/rcall_recipient/'+rcallRecipientId+'/status', function(data){
    console.log(data.call_status)
    if (data.call_status === 'completed' || data.call_status === 'failed'){
      // If these statuses aren't returned, assume call has finished
      showCallingDoneScreen()
    } else {
      setTimeout(function(){
        pollCallingStatus(rcallRecipientId)
      }, 2000)
    }
  })
}

function showCallingDoneScreen(){
  $('.call-list-options').addClass('hidden')
  $('.call-finished-options').removeClass('hidden')
}

function showCallingListScreen(){
  // remove reps we've already called
  $('.js-dial-representative').find('.call-in-progress-icon').not('.hidden').parent().each(function(ind, button){
    button = $(button)
    button.html(button.html().replace("Connect to", "You've already called"))
    button.addClass('called')
    button.attr('disabled', true)
  })

  $('.js-dial-representative:not(.called)').attr('disabled', false)
  $('.js-dial-representative').find('.call-icon').removeClass('hidden')
  $('.js-dial-representative').find('.call-in-progress-icon').addClass('hidden')

  $('.call-list-options').removeClass('hidden')
  $('.call-finished-options').addClass('hidden')
}

function setCallingOn(button){
  $('.js-dial-representative').attr('disabled', true)
  $(button).find('.call-icon').addClass('hidden')
  $(button).find('.call-in-progress-icon').removeClass('hidden')
}

function setCallingOff(button){
  $('.js-dial-representative').attr('disabled', false)
  $(button).find('.call-icon').removeClass('hidden')
  $(button).find('.call-in-progress-icon').addClass('hidden')
}


/*** EXPORTS FROM exports-loader ***/
exports["setupRActionCall"] = (setupRActionCall);
exports["pollCallingStatus"] = (pollCallingStatus);
exports["showCallingListScreen"] = (showCallingListScreen);
exports["showCallingDoneScreen"] = (showCallingDoneScreen);
exports["setCallingOn"] = (setCallingOn);
exports["setCallingOff"] = (setCallingOff);